/**
 * Copyright (c) 2020-present, Bruno Carvalho de Araujo.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */

export type Token = {
  accessToken: string
}

/**
 * Responsável por armazenar e gerenciar os tokens da sessão do usuário
 */
export class Keychain {
  /**
   * armazena o token no storage
   */
  setToken (value: Token): Promise<void> {
    return Promise.resolve(localStorage.setItem('SSO_TOKEN_SESSION', value))
  }

  /**
   * recupera o token armazenado no storage
   */
  getToken (): Promise<Token> {
    return Promise.resolve(localStorage.getItem('SSO_TOKEN_SESSION'))
  }

  /**
   * remove o token armazenado no storage
   */
  removeToken (): Promise<void> {
    return Promise.resolve(localStorage.removeItem('SSO_TOKEN_SESSION'))
  }

  /**
   * verifica se existe um token no storage
   */
  hasToken (): Promise<boolean> {
    return this.getToken()
      .then(token => token !== null)
  }
}
